import { useContext, useState } from "react";
import HeadlessDialog from "@components/Dialog";
import HeadlessButton from "@components/Button";
import { sendRegistrationEmail } from "@service/contractorService";
import { SnackbarContext } from "@components/constant_components/providers/SnackbarProvider";
import Spinner from "@components/Spinner";
import { MdEmail } from "react-icons/md";

interface ISendRegistrationEmailModalProps {
  worker_id: number;
  contractor_name: string;
  isOpen: boolean;
  onClose: () => void;
}

export function SendRegistrationEmailModal({
  worker_id,
  contractor_name,
  isOpen,
  onClose,
}: ISendRegistrationEmailModalProps): JSX.Element {
  const { triggerSnackbar } = useContext(SnackbarContext);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSendEmail = async () => {
    setIsSubmitting(true);
    try {
      await sendRegistrationEmail(worker_id);
      triggerSnackbar("Registration email sent successfully.");
      onClose();
    } catch (err) {
      if (
        typeof err === "object" &&
        err !== null &&
        "response" in err &&
        typeof (err as any).response === "object" &&
        (err as any).response !== null &&
        "data" in (err as any).response &&
        typeof (err as any).response.data === "object" &&
        (err as any).response.data !== null &&
        "error" in (err as any).response.data
      ) {
        triggerSnackbar(
          `Failed to send registration email: ${
            (err as any).response?.data?.error || err
          }`
        );
      } else {
        triggerSnackbar(`Failed to send registration email: ${String(err)}`);
      }
      console.error("Failed to send registration email:", err);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      {isOpen && (
        <HeadlessDialog
          title={
            <div className="tw-flex tw-items-center tw-gap-2">
              <MdEmail className="tw-text-primary-light" size={24} />
              <span>Send Registration Email</span>
            </div>
          }
          description=""
          isOpen={isOpen}
          setIsOpen={onClose}
          onClose={onClose}
          buttonText="Close"
          size="tw-w-[100vw] md:tw-max-w-[40vw]"
        >
          <div className="tw-p-4">
            <div className="tw-text-lg tw-font-bold tw-text-primary-light tw-mb-4">
              {contractor_name}
            </div>
            <p className="tw-mb-6 tw-text-gray-700">
              Are you sure you want to send a registration email to this
              contractor?
            </p>
            <div className="tw-flex tw-justify-end">
              <HeadlessButton
                type="button"
                onClick={handleSendEmail}
                disabled={isSubmitting}
                className="tw-w-[200px] tw-h-10"
              >
                {isSubmitting ? (
                  <Spinner className="tw-flex tw-justify-center tw-items-center" />
                ) : (
                  "Send Registration Email"
                )}
              </HeadlessButton>
            </div>
          </div>
        </HeadlessDialog>
      )}
    </>
  );
}
